import extend from 'quasar/src/utils/extend/extend.js';
import { reactive } from "vue";
import { api } from "~/api";
import { Personal } from "~/api/data/Personal";
import { Log } from "~/extensions/utils";
import { auth } from "../core";
import { LatestAsyncStatus, UserKb } from "~/extensions/utils/DefineTypes";
import { Nyukyokeiyaku } from "~/api/data/Nyukyokeiyaku";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
const log = Log.create("MyPageStore");
class MyPageStore {
    data = null;
    loadError = false;
    resultStatus = -1;
    lastSyncDate = "";
    nyukyoStatus = -1;
    shinseiStatus = -1;
    basicPromise = null;
    nyukyoPromise = null;
    shinseiPromise = null;
    /**選択部屋入居契約No. */
    selectedNyukyokeiyakuNo = -1;
    get keyName() {
        return "";
    }
    load(isForceGetLatest = false) {
        this.clear();
        if (!auth.isAuthenticated) {
            return;
        }
        this.loadError = false;
        try {
            if (auth.user?.userKbn === UserKb.Tenant) {
                const basicPromise = api.latest.getLatestBasic(isForceGetLatest);
                const nyukyoPromise = api.latest.getLatestNyukyo(isForceGetLatest);
                const shinseiPromise = api.latest.getLatestShinsei(isForceGetLatest);
                this.basicPromise = basicPromise
                    .then((basicResult) => {
                    this.data = basicResult;
                    this.resultStatus = basicResult.resultStatus ?? -1;
                    this.lastSyncDate = basicResult?.lastSyncDate ?? "";
                    this.selectedNyukyokeiyakuNo = this.data?.nyukyokeiyakuList[0]?.orgNyukyokeiyakuNo ?? -1;
                })
                    .catch(() => {
                    this.loadError = true;
                });
                this.nyukyoPromise = nyukyoPromise
                    .then((nyukyoResult) => {
                    this.nyukyoStatus = nyukyoResult ?? -1;
                })
                    .catch(() => {
                    this.nyukyoStatus = LatestAsyncStatus.Error;
                });
                this.shinseiPromise = shinseiPromise
                    .then((shinseiResult) => {
                    this.shinseiStatus = shinseiResult ?? -1;
                })
                    .catch(() => {
                    this.shinseiStatus = LatestAsyncStatus.Error;
                });
            }
        }
        catch {
            this.loadError = true;
        }
    }
    async waitForBasic() {
        if (this.basicPromise) {
            await this.basicPromise;
        }
        return this.resultStatus;
    }
    async waitForNyukyo() {
        if (this.nyukyoPromise) {
            await this.nyukyoPromise;
        }
        return this.nyukyoStatus;
    }
    /**入居者情報の有無 */
    isNoData() {
        return auth.user?.userKbn === UserKb.Tenant && (this.data == null || this.data.keiyakusha === "");
    }
    get personal() {
        let copy = new Personal();
        extend(true, copy, this.data);
        return copy;
    }
    /** 選択部屋情報 */
    get selectedNyukyokeiyaku() {
        if (this.data?.nyukyokeiyakuList.length === 1) {
            return this.data?.nyukyokeiyakuList[0];
        }
        const nyukyokeiyaku = this.data?.nyukyokeiyakuList.find(x => x.orgNyukyokeiyakuNo === this.selectedNyukyokeiyakuNo);
        if (!isNullOrUndefined(nyukyokeiyaku)) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return nyukyokeiyaku;
        }
        return new Nyukyokeiyaku();
    }
    /** 複数契約 */
    get isMultipleKeiyaku() {
        if (isNullOrUndefined(this.data) || isNullOrUndefined(this.data?.nyukyokeiyakuList)) {
            return false;
        }
        return (this.data?.nyukyokeiyakuList.length ?? 0) > 1;
    }
    clear() {
        this.data = null;
        this.loadError = false;
        this.resultStatus = -1;
        this.lastSyncDate = "";
        this.nyukyoStatus = -1;
        this.selectedNyukyokeiyakuNo = -1;
    }
}
export let myPageStore = reactive(new MyPageStore());
